var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQueryClient } from "react-query";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import ProductDetail from "./ProductDetail";
import { ProductFilters } from "../../components/ProductFilters";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { useProductFilters } from "../../hooks/useProductFilters";
import { useProductData } from "../../hooks/useProductData";
import { useProductTable } from "../../hooks/useProductTable";
import { useTableSort } from "../../hooks/useTableSort";
import { useProductActions } from "../../hooks/useProductActions";
import { usePublishersData } from "../../hooks/usePublishersData";
import { updateProductAccessibility } from "../../api/productService";
import { ProductAccessibilityEnum } from "../../types/Api";
import { ProductAccessibilityConfirmModal } from "../../components/ProductAccessibilityConfirmModal";
import { ProductActionButtons } from "../../components/ProductActionButtons";
import { ProductPublishingDateRequiredModal } from "../../components/ProductPublishingDateRequiredModal";
import { usePermissions } from "../../hooks/usePermissions";
import { useCanAssignProductNumber } from "../../hooks/useCanAssignProductNumber";
import { useMakePublicGuard } from "../../hooks/product/useMakePublicGuard";
import { usePageSize } from "../../hooks/usePageSize";
import { COLUMN_LAYOUT_KEYS } from "../../utils/constants";
import { useProductDelete } from "../../hooks/product/useProductDelete";
import { ProductDeleteModals } from "../../components/product/ProductDeleteModals";
import { CurrentUserLoadErrorBanner } from "../../components/CurrentUserLoadErrorBanner";
var ProductList = function () {
    var _a, _b, _c, _d, _e, _f;
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _g = React.useState(true), filterPaneIsVisible = _g[0], setFilterPaneIsVisible = _g[1];
    var filtersHook = useProductFilters();
    var _h = usePublishersData(filtersHook.publisherQuery, filtersHook.filters.publisherId), publishers = _h.publishers, publishersLoading = _h.publishersLoading, selectedPublisher = _h.selectedPublisher;
    var _j = usePublishersData("", filtersHook.appliedFilters.publisherId), appliedPublisher = _j.selectedPublisher, appliedPublisherLoading = _j.selectedPublisherLoading;
    var _k = usePageSize(), pageSize = _k.pageSize, createPageSizeHandler = _k.createPageSizeHandler;
    var _l = useTableSort(), sort = _l.sort, handleHeaderClick = _l.handleHeaderClick;
    var dataHook = useProductData(filtersHook.appliedFilters, filtersHook.buildQuery, appliedPublisher, pageSize, sort, 
    // a search before the publisher is known would be thrown away
    filtersHook.filtersReady && !appliedPublisherLoading);
    var handleSortHeaderClick = function (columnId) {
        dataHook.resetPageOffset();
        handleHeaderClick(columnId);
    };
    var handleApplyFilters = function () {
        // Enter submits the filter form even while Apply is disabled.
        if (filtersHook.hasInvalidDateRange)
            return;
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var actionsHook = useProductActions();
    var columns = useProductTable(actionsHook.handleRowClick).columns;
    var _m = usePermissions(), canEditProductItem = _m.canEditProductItem, canChangeProductAccessibility = _m.canChangeProductAccessibility, hasPublicOnlyView = _m.hasPublicOnlyView, canDeleteProductItem = _m.canDeleteProductItem;
    var _o = useCanAssignProductNumber(actionsHook.selectedProduct), canAssignProductNumber = _o.canAssignProductNumber, productNumbersData = _o.productNumbersData;
    var selectedProductNumbers = (_a = productNumbersData === null || productNumbersData === void 0 ? void 0 : productNumbersData.items) !== null && _a !== void 0 ? _a : [];
    var canDelete = !!productNumbersData &&
        canDeleteProductItem(actionsHook.selectedProduct, selectedProductNumbers.length > 0);
    var productDelete = useProductDelete({
        onDeleted: function () {
            actionsHook.handleCloseDetail();
            dataHook.refetch();
        },
    });
    var _p = React.useState(false), isAccessibilityModalOpen = _p[0], setIsAccessibilityModalOpen = _p[1];
    var _q = React.useState(null), pendingAccessibility = _q[0], setPendingAccessibility = _q[1];
    var publishGuard = useMakePublicGuard();
    var accessibilityMutation = useMutation(function (_a) {
        var id = _a.id, accessibility = _a.accessibility;
        return updateProductAccessibility(ky, id, accessibility);
    }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(["products"]);
            queryClient.invalidateQueries([
                "product",
                (_a = actionsHook.selectedProduct) === null || _a === void 0 ? void 0 : _a.id,
            ]);
            setIsAccessibilityModalOpen(false);
            setPendingAccessibility(null);
            dataHook.refetch();
        },
    });
    var handleMakePublic = function () {
        var product = actionsHook.selectedProduct;
        if (!product)
            return;
        publishGuard.requestMakePublic(product, function () {
            setPendingAccessibility(ProductAccessibilityEnum.PUBLIC);
            setIsAccessibilityModalOpen(true);
        });
    };
    var handleMakePrivate = function () {
        setPendingAccessibility(ProductAccessibilityEnum.PRIVATE);
        setIsAccessibilityModalOpen(true);
    };
    var confirmAccessibilityChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (((_a = actionsHook.selectedProduct) === null || _a === void 0 ? void 0 : _a.id) && pendingAccessibility) {
                accessibilityMutation.mutate({
                    id: actionsHook.selectedProduct.id,
                    accessibility: pendingAccessibility,
                });
            }
            return [2 /*return*/];
        });
    }); };
    var cancelAccessibilityChange = function () {
        setIsAccessibilityModalOpen(false);
        setPendingAccessibility(null);
    };
    var handleEdit = function () {
        var _a;
        history.push("/bragency/products/edit/".concat((_a = actionsHook.selectedProduct) === null || _a === void 0 ? void 0 : _a.id));
    };
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var source = createStripesSource({
        ky: null,
        data: dataHook.productsData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading || dataHook.isWaitingForFilters,
        isError: dataHook.isError,
        isLoaded: true,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    var productName = ((_e = (_d = (_c = (_b = actionsHook.selectedProduct) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.names) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.name) ||
        ((_f = actionsHook.selectedProduct) === null || _f === void 0 ? void 0 : _f.id) ||
        "";
    var handleAddProductNumber = function () {
        var _a;
        history.push("/bragency/product-numbers/assign/".concat((_a = actionsHook.selectedProduct) === null || _a === void 0 ? void 0 : _a.id));
    };
    var hasAnyAction = actionsHook.selectedProduct
        ? canEditProductItem(actionsHook.selectedProduct) ||
            canChangeProductAccessibility(actionsHook.selectedProduct) ||
            canAssignProductNumber ||
            canDelete
        : false;
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductAccessibilityConfirmModal, { open: isAccessibilityModalOpen, productName: productName, pendingAccessibility: pendingAccessibility, onConfirm: confirmAccessibilityChange, onCancel: cancelAccessibilityChange }),
        React.createElement(ProductPublishingDateRequiredModal, { open: publishGuard.isGuardOpen, onEdit: publishGuard.goToEdit, onCancel: publishGuard.closeGuard }),
        React.createElement(ProductDeleteModals, { state: productDelete }),
        React.createElement(RecekPaneSet, null,
            filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-agency.pane.title.navigation",
                }) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null),
                    React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                    React.createElement(ProductFilters, { filters: filtersHook.filters, publishers: publishers, publishersLoading: publishersLoading, selectedPublisher: selectedPublisher, onFilterChange: filtersHook.handleFilterChange, onAccessibilityChange: filtersHook.handleAccessibilityChange, onApplyFilters: handleApplyFilters, onPublisherInput: filtersHook.handlePublisherInput, hasUnappliedChanges: filtersHook.hasUnappliedChanges(), hasInvalidDateRange: filtersHook.hasInvalidDateRange, dateInputs: filtersHook.dateInputs, showAccessibilityFilter: !hasPublicOnlyView })))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.product.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }) },
                React.createElement(CurrentUserLoadErrorBanner, { show: filtersHook.currentUserLoadFailed }),
                React.createElement(TableComponent, { data: dataHook.productsData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, sortedColumn: sort.column, sortDirection: sort.column ? sort.direction : undefined, onHeaderClick: handleSortHeaderClick, layoutKey: COLUMN_LAYOUT_KEYS.PRODUCTS })),
            actionsHook.selectedProduct && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.product.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: hasAnyAction
                    ? function () { return (React.createElement(ProductActionButtons, { product: actionsHook.selectedProduct, onEdit: handleEdit, onMakePublic: handleMakePublic, onMakePrivate: handleMakePrivate, onAddProductNumber: canAssignProductNumber
                            ? handleAddProductNumber
                            : undefined, onDelete: canDelete
                            ? function () {
                                return productDelete.openDeleteConfirm(actionsHook.selectedProduct, selectedProductNumbers);
                            }
                            : undefined })); }
                    : undefined },
                React.createElement(ProductDetail, null))))));
};
export { ProductList };
